import { NUMBER_FORMAT_LOCALES } from '../constant/constants';

/**
 * Formats a number according to the selected locale format.
 *
 * value - The numeric value to format.
 * format - Number format type ("US" or "EU").
 * Formatted number string with 2 decimal places, or empty string if invalid.
 *
 */

export const numberFormatter = (value: number, format: keyof typeof NUMBER_FORMAT_LOCALES) => {
  if (value === null || value === undefined || isNaN(value)) return '';

  return new Intl.NumberFormat(NUMBER_FORMAT_LOCALES[format], {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  }).format(value);
};
